var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%"}},[_vm._t("default",null,{"titles":_vm.titleData},_vm.$props)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }